import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import styles from './CourseCard.module.scss';
import { ReactComponent as ArrowIcon } from './images/arrow.svg';

import { BuyButton } from '../BuyButton';
import { CourseCardType, Price } from '../../constants';
import { useLocalStorage } from '../../hooks';

type Props = {
  price: Price;
  card: CourseCardType;
  onValidationOpen(): void;
  onSendEvent(): void;
};

const TAG_TEXT = '5 прямых эфиров';
const MORE_TEXT = 'Подробнее';
const BUTTON_PLACE = 'course-card';

export function CourseCard({ price, card, onValidationOpen, onSendEvent }: Props) {
  const { id, title, date, description, description1440, description960, list, icon, bgColor } =
    card;
  const [seenSorry] = useLocalStorage('seenSorry', false);

  const Icon = icon;
  return (
    <div className={styles.courseCard}>
      <div className={styles.cardUpperWrapper} style={{ backgroundColor: bgColor }}>
        <p className={styles.cardTag}>{TAG_TEXT}</p>
        <div className={styles.cardDate} dangerouslySetInnerHTML={{ __html: date }} />
        <p
          className={cn(styles.cardTitle, id === 10 && styles.cardTitle_moove)}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <Icon className={styles.cardIcon} />
      </div>
      <Link to={`${id}`} className={styles.cardMore}>
        {MORE_TEXT}
        <ArrowIcon className={styles.arrow} />
      </Link>
      <div className={styles.cardContent}>
        <p
          className={cn(styles.description, styles.description_max)}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <p
          className={cn(styles.description, styles.description_1440)}
          dangerouslySetInnerHTML={{ __html: description1440 }}
        />
        <p
          className={cn(styles.description, styles.description_960)}
          dangerouslySetInnerHTML={{ __html: description960 }}
        />

        <ul className={styles.list}>
          {list.map((item) => (
            <React.Fragment key={item.text}>
              <p
                className={cn(styles.listItemText, styles.listItemText_max)}
                dangerouslySetInnerHTML={{ __html: item.text }}
              />
              <p
                className={cn(styles.listItemText, styles.listItemText_1440)}
                dangerouslySetInnerHTML={{ __html: item.text1440 }}
              />
              <p
                className={cn(styles.listItemText, styles.listItemText_960)}
                dangerouslySetInnerHTML={{ __html: item.text960 }}
              />
            </React.Fragment>
          ))}
        </ul>
      </div>
      {!seenSorry && (
        <>
          <div className={styles.cardButtonWrapper}>
            <BuyButton
              text={`Купить курс за ${price.price} ₽`}
              place={BUTTON_PLACE}
              onClick={() => {
                onSendEvent();
                onValidationOpen();
              }}
            />
            <div className={styles.discount}>
              <div className={styles.discountBasePrice}>{price.basePrice}&nbsp;₽</div>
              <div>{price.discount}</div>
            </div>
          </div>
          <div className={styles.cardFooter}>{`${price.priceForLesson} ₽ за один эфир`}</div>
        </>
      )}
    </div>
  );
}
